import { useAtom } from "../editor-jotai";
import { t } from "../i18n";
import { useRecording } from "../recording/useRecording";

import { atom } from "../editor-jotai";

import ConfirmDialog from "./ConfirmDialog";

export const stopRecordingDialogAtom = atom<boolean>(false);

export const StopRecordingConfirmDialog = () => {
  const [isOpen, setIsOpen] = useAtom(stopRecordingDialogAtom);
  const { stopRecording } = useRecording();

  if (!isOpen) {
    return null;
  }

  return (
    <ConfirmDialog
      onConfirm={() => {
        stopRecording();
        setIsOpen(false);
      }}
      onCancel={() => setIsOpen(false)}
      title={t("recording.stopConfirmTitle")}
      confirmText={t("recording.stopRecording")}
    >
      <p style={{ margin: "8px 0", fontSize: 14 }}>
        {t("recording.stopConfirmMessage")}
      </p>
    </ConfirmDialog>
  );
};
